import { Workspace, WorkspaceRoleId, Role } from "../../../../state/types";
import { DEFAULT_BASE_ROLE_OPTIONS } from "./roles";

export const getTeamMemberRoles = (
    workspace?: Workspace,
    userId?: string
): { customRoles: WorkspaceRoleId[]; baseRole: Role; primaryRole: WorkspaceRoleId } => {
    const customRoles = userId ? workspace?.userCustomRoles?.[userId] : [];
    const baseRole = userId ? workspace?.roles?.[userId] : DEFAULT_BASE_ROLE_OPTIONS[0].value;

    const primaryRole = workspace?.customRolesEnabled ? customRoles?.[0] : baseRole;

    return {
        customRoles: customRoles || [],
        baseRole: baseRole || DEFAULT_BASE_ROLE_OPTIONS[0].value,
        primaryRole: primaryRole || baseRole || DEFAULT_BASE_ROLE_OPTIONS[0].value
    };
};
